<template>
  <div class="main">
    <clouded-glass class="space-choose">
      <div class="h-100 overflow-auto" slot="content">
        <div style="display: flex;align-items: center;justify-content: center;margin-top: 20px">
          <el-radio-group size="small" v-model="systemType" @change="changeType">
            <el-radio-button label="1">电力</el-radio-button>
            <el-radio-button label="2">群控</el-radio-button>
            <el-radio-button label="3">PTMS</el-radio-button>
          </el-radio-group>
        </div>
        <div class="space-button text-center">
          <span @touchstart="openDialog({}, 'same')" @click="openDialog({}, 'same')">新建同级组态空间</span>
          <span @touchstart="openDialog({}, 'children')" @click="openDialog({}, 'children')">新建子级组态空间</span>
        </div>
        <div class="space-button text-center">
          <span @touchstart="openDialog(checkSpace, 'edit')" @click="openDialog(checkSpace, 'edit')">编辑选中组态空间</span>
          <span class="text-danger" style="border-color: darkred" @touchstart="removeSpace"
            @click="removeSpace">删除选中组态空间</span>
        </div>
        <div class="current-location" style="margin-right: 21px">
          <el-input class="inline-input" v-model="name" placeholder="请输入搜索的组态空间名称" size="mini" @change="changeName" />
        </div>
        <div class="current-location">
          <img alt="" src="../../../../assets/images/icon/location.png" />
          当前组态空间:
          <span class="text-nowrap text-lightBlue">{{ checkSpace.title }}</span>
        </div>
        <space-tree-show @spaceChoose="spaceChoose" :systemType="systemType" :checkShow="false" class="space"
          ref="space" />
      </div>
    </clouded-glass>

    <div class="contentRight">
      <el-row style="width: 100%; overflow: auto; height: 100vh">
        <div class="container_warp" style="flex-direction: row">
          <!-- <el-row
            style="
              width: 100%;
              height: 30px;
              padding-bottom: 10px;
              z-index: 1;
            "
          >
            <el-col
              style="
                display: flex;
                align-items: center;
                justify-content: flex-end;
              "
            >
              <div style="margin-right: 30px">
                <el-image
                  :src="editGragh"
                  style="width: 14px; height: 14px; margin-right: 3px"
                  fit="fill"
                ></el-image>
                <span style="color: #07e6f8; cursor: pointer" @touchstart="uploadSvg" @click="uploadSvg"
                  >导入SVG</span
                >
              </div>

            </el-col>
          </el-row> -->
          <div v-if="svgData.url" id="svgContainer" ref="svgContainer" ></div>
          <noData v-else style="
              height: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
            "></noData>
        </div>
      </el-row>
    </div>

    <uploadDialog :title="title" :spaceForm="spaceForm" :spaceLabel="spaceLabel" :spaceValue="checkSpace.title"
      :dialogVisible="uploadDialogVisible" @closeUploadDialog="closeUploadDialog"></uploadDialog>

    <dialog-component :closeClick="false" :dialog-title="title" :dialogVisible.sync="deviceDialogVisible" center
      width="45vw" @dialogClose="(data) => this.deviceDialogVisible = data">
      <div slot="content" style="padding: 10px 30px 20px 30px;">
        <div style="height: 30vh; margin: auto">
          <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
            <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7"
              style="line-height: 28px;text-align: right;margin-right: 10px;">
              {{ spaceLabel }}：
            </el-col>
            <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
              <span class="text-blue" style="font-size: inherit;height: 28px;line-height: 28px;">{{ checkSpace.title
              }}</span>
            </el-col>
          </el-col>
          <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
            <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7"
              style="line-height: 28px;text-align: right;margin-right: 10px;">
              组态空间名称：
            </el-col>
            <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
              <el-input class="inline-input" placeholder="请输入组态空间名称" size="mini" style="width: 80%"
                v-model="spaceForm.cnName"></el-input>
            </el-col>
          </el-col>
          <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
            <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7"
              style="line-height: 28px;text-align: right;margin-right: 10px;">
              是否是逻辑组态空间：
            </el-col>
            <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
              <el-select @change="select_status" collapse-tags placeholder="请选择" size="mini"
                style="padding-bottom: 5px;width: 80%" v-model="spaceForm.type">
                <el-option :value="1" label="是"></el-option>
                <el-option :value="0" label="否"></el-option>
              </el-select>
            </el-col>
          </el-col>
          <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
            <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7"
              style="line-height: 28px;text-align: right;margin-right: 10px;">
              备注：
            </el-col>
            <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
              <el-input :rows="2" autosize class="inline-input" placeholder="请输入备注" style="width: 80%" type="textarea"
                v-model="spaceForm.note">
              </el-input>
            </el-col>
          </el-col>
          <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
            <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7"
              style="line-height: 28px;text-align: right;margin-right: 10px;">
              导入SVG：
            </el-col>
            <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15" v-if="spaceForm.bgImage">
              <div class="upload-div">
                <img :src="$ftpUrl + spaceForm.bgImage" class="upload-img">
                <div class="delete-icon">
                  <span @touchstart="imageRemove" @click="imageRemove">
                    <i class="el-icon-delete"></i>
                  </span>
                </div>
              </div>
            </el-col>
            <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15" v-else>
              <el-upload :action="uploadUrl" :auto-upload="true" :headers="token" :before-upload="beforeUpload"
                :accept="'image/*'" :on-error="imageChangeError" :on-success="imageChangeSuccess"
                :show-file-list="false" class="upload-demo" drag style="margin-bottom: 60px;"
                v-model="spaceForm.bgImage">
                <i class="el-icon-plus" style="line-height:80px;height: 80px;width: 80px;"></i>
              </el-upload>
            </el-col>
          </el-col>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;margin-bottom: 15px;">
        <el-button @touchstart="close" @click="close" size="mini">关 闭</el-button>
        <el-button @touchstart="preservation" @click="preservation" type="primary" size="mini">保 存</el-button>
      </div>
    </dialog-component>
  </div>
</template>

<script>
import CloudedGlass from "@/components/style/CloudedGlass";
import SpaceTreeShow from "@/components/space/SpaceTreeShowCopy";
import Panzoom from "panzoom";
import noData from "@/components/NoData";
import uploadDialog from "./comp/upload.vue";
import {
  importTopology,
  importTopologyGateway,
  getDataByDeviceIdsAndPointIds
} from "@/network/device-topology";
import { deleteById, getSpaceInfoById, saveByLevel } from "@/network/power-wiring-diagram";
// import { getSystematicByCodes } from "@/network/systematic";
// import { tree } from "@/network/ext-geography";
import DialogComponent from "@/components/DialogComponent";
import _ from 'lodash';
import { serviceUrl } from "@/utils/request";
import { imgUploadAstrict } from '@/constant/img-upload-astrict';

export default {
  name: "DeviceTopology",
  components: {
    CloudedGlass,
    SpaceTreeShow,
    noData,
    uploadDialog,
    DialogComponent
  },

  data() {
    return {
      systemType: '1',
      name: "",
      checkSpace: {},
      editGragh: require("../../../../assets/images/antVx6/edit.png"),
      svgDom: null,
      allDom: null,
      panzoom: null,
      uploadDialogVisible: false,
      spaceLabel: "",
      spaceForm: {},
      title: "",
      svgData: {
        url: ''
      },
      // 上传按钮配置
      uploadButtons: [
        {
          label: "导入关联设备ID匹配",
          type: "normal",
          api: importTopology,
        },
        {
          label: "导入开关闸",
          type: "gateway",
          api: importTopologyGateway,
        },
      ],
      currentFiles: {
        normal: null,
        gateway: null,
      },
      deviceDialogVisible: false,
      operate: "",
      levelType: 0,
      code: null,
      options: [],
      token: {
        Authorization: 'Bearer' + this.$cookies.get('token')
      },
      allowSuffix: ["bmp", "jpg", "png", "tif", "gif", "pcx", "tga", "exif", "fpx", "svg", "psd", "cdr", "pcd", "dxf", "ufo", "eps", "ai", "raw", "WMF", "webp"],
      uploadUrl: window.g.gatewayUrl.slice(0, -1) + serviceUrl.deviceService + '/api/upload',
    };
  },

  created() {
    this.queryTopology();
  },

  watch: {
    checkSpace: {
      handler() {
        this.queryTopology();
      },
      deep: true,
    },
  },

  methods: {
    // 查询当前组态空间拓扑图
    queryTopology() {
      console.log(this.checkSpace.id, 'this.checkSpace.id');
      if (!this.checkSpace.id) return;

      getSpaceInfoById(this.checkSpace.id, this.systemType)
        .then((res) => {
          if (res.code === 0 && res.data) {
            console.log(res.data, 'res.data');
            this.svgData.url = res.data.bgImage;
            const svgUrl = this.$ftpUrl + this.svgData.url;
            this.getSvg(svgUrl);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },

    spaceChoose(spaceInfo) {
      if (spaceInfo.type === 1) {
        this.$message.error("此组态空间为逻辑组态空间,无法选择");
        const node = this.$refs.space.ztreeObj.getNodeByParam(
          "id",
          this.checkSpace.id
        );
        this.$refs.space.ztreeObj.selectNode(node);
        return;
      }
      this.checkSpace = spaceInfo;
    },

    changeName() {
      this.$refs.space.changName(this.name);
    },

    getSvg(wftSvg) {
      fetch(wftSvg)
        .then((res) => res.text())
        .then((svgText) => {
          this.$refs.svgContainer.innerHTML = svgText;
          const svgElement = this.$refs.svgContainer.querySelector('svg');

          if (svgElement) {
            svgElement.style.width = '100%';
            svgElement.style.height = '100%';
            svgElement.setAttribute('preserveAspectRatio', 'xMidYMid meet');
          }

          this.initPanZoom();
        });
    },

    initPanZoom() {
      this.$nextTick(() => {
        if (!this.$refs.svgContainer) {
          console.warn("svgContainer 还未渲染，无法初始化 Panzoom");
          return;
        }

        this.panzoom = Panzoom(this.$refs.svgContainer, {
          maxScale: 2,
          minScale: 0.1, // 避免缩放为 0
          overflow: "auto",
          canvas: true,
        });
        // 自动调整缩放以适应容器
        const container = this.$refs.svgContainer;
        const svg = container.querySelector('svg');
        if (svg) {
          const containerRect = container.getBoundingClientRect();
          const svgRect = svg.getBoundingClientRect();

          // 计算合适的缩放比例
          const scaleX = containerRect.width / svgRect.width;
          const scaleY = containerRect.height / svgRect.height;
          const scale = Math.min(scaleX, scaleY) * 0.9; // 留出一些边距

          // 应用缩放和居中
          this.panzoom.zoomTo(0, 0, scale);

          // 计算居中位置
          const centerX = (containerRect.width - (svgRect.width * scale)) / 2;
          const centerY = (containerRect.height - (svgRect.height * scale)) / 2;

          this.panzoom.moveTo(centerX, centerY);
        }
      });
    },

    async uploadSvg() {
      if (!this.checkSpace.id) {
        this.$message.error("请先选择组态空间");
        return;
      }
      this.spaceForm = {
        spaceId: this.checkSpace.id,
        url: this.svgData.url,
        id: this.svgData.id,
        name: this.svgData.name,
      };
      this.title = "上传SVG";
      this.spaceLabel = "操作组态空间";
      this.uploadDialogVisible = true;
    },

    closeUploadDialog(tag) {
      if (tag) {
        this.queryTopology();
      }
      this.uploadDialogVisible = false;
    },

    // 文件上传前检查
    beforeImportUpload(file) {
      const fileSize = file.size;
      const FIVE_M = 5 * 1024 * 1024;
      if (fileSize > FIVE_M) {
        this.$message.error("最大上传5M");
        return false;
      }
      return true;
    },

    // 处理文件选择改变
    handleChange(file, index) {
      const type = this.uploadButtons[index].type;
      this.currentFiles[type] = file.raw;
      this.$refs[`uploadRef${index}`][0].submit();
    },

    // 处理超出限制
    handleImportExceed() {
      this.$message.error("最多支持1个附件上传");
    },

    updateSvg() {
      const svg = this.$refs.svgContainer;
      this.handleSvg(svg);
    },
    // 通过id数组获取对应的测点值
    getIdsReturnValue(obj) {
      return new Promise((resolve) => {
        // 调用接口获取数据

        getDataByDeviceIdsAndPointIds(obj.deviceIds, obj.pointids)
          .then(res => {
            // 检查返回数据是否有效
            if (!res || !res.data) {
              console.error('返回数据无效');
              resolve({
                deviceIds: [],
                pointids: []
              });
              return;
            }

            const idsObj = res.data;

            // 构造返回数据结构
            const result = {
              deviceIds: idsObj.devicesList.map(item => ({
                deviceid: item.id,
                status: item.status,
                deviceName: item.deviceName || ''
              })),
              pointids: idsObj.pointsLists.map(item => ({
                pointid: item.pointId,
                pointValue: item.pointValue,
                pointName: item.pointName,
                pointValueName: item.pointValueName
              }))
            };

            // 返回处理后的数据
            resolve(result);
          })
          .catch(error => {
            console.error('获取设备和测点数据失败:', error);
            // 发生错误时返回空数据结构
            resolve({
              deviceIds: [],
              pointids: []
            });
          });
      });
    },
    // 处理svg图片
    async handleSvg() {
      const svg = this.$refs.svgContainer;
      console.log(svg, "svg");
      // 1.首先拿到所有id集合 device_id point_id 换取对应的值
      const deviceIdElements = svg.querySelectorAll("g[data-deviceid]");
      const deviceIds = Array.from(deviceIdElements).map(
        (element) => element.dataset.deviceid
      );
      const pointidElements = svg.querySelectorAll("g[data-pointid]");
      const pointids = Array.from(pointidElements).map(
        (element) => element.dataset.pointid
      );
      console.log(deviceIds, pointids);
      const idsObj = await this.getIdsReturnValue({
        deviceIds,
        pointids,
      });
      console.log(idsObj, "idsObj");
      // 2.处理设备（1、不是自己上传的图片设备。此时device_id只有一个，告警变成红色，正常颜色是黑色或绿色，自己上传的图片设备，此时device_id有两个，还需要配置一个status，status为0表示正常，2表示告警，换成红色或绿色的设备图片）
      idsObj.deviceIds.forEach((item) => {
        console.log(item, "item");
        const currentStatus = item.status;
        const currentDeviceId = item.deviceid;
        Array.from(deviceIdElements).forEach((element) => {
          // const status = element.dataset.status
          console.log(element, "element", currentDeviceId, "currentDeviceId");
          if (currentDeviceId == element.dataset.deviceid) {
            //  情况如果当前element的dataset存在status
            if (element.dataset.status) {
              console.log(element.dataset.status, "status", currentStatus);
              if (element.dataset.status == "0" && currentStatus == "2") {
                console.log(element, "element111");
                element.style.display = "none";
              } else if (
                element.dataset.status == "2" &&
                currentStatus == "0"
              ) {
                console.log(element, "element222");
                element.style.display = "none";
              }
            } else {
              if (currentStatus === "2") {
                // element.style.fill = "red";
                this.updateElementColor(element, 'green')
              } else {
                this.updateElementColor(element, 'black')

                // const childElements = element.querySelectorAll("path, ellipse");

                // childElements.forEach((el) => {
                //   el.style.fill = "black";
                //   el.style.stroke = "black";
                // });
              }
            }
          }
        });
      });
      // 3.区分是text框还是开关闸还是线：text框只有一个pinot_id，开关闸有两个point_id和Value属性，线只有一个point_id
      // 3.区分是text框还是开关闸还是线
      const textArr = [];
      const tempArr = []; // 临时存放开关闸和线
      const LineArr = [];
      const switchArr = [];

      // 第一步：区分text框和其他（开关闸和线）
      const pointidGroups = {};
      Array.from(pointidElements).forEach((element) => {
        const pointid = element.dataset.pointid;
        if (!pointidGroups[pointid]) {
          pointidGroups[pointid] = [];
        }
        pointidGroups[pointid].push(element);
      });

      // 遍历分组后的元素
      Object.entries(pointidGroups).forEach(([pointid, elements]) => {
        if (elements.length === 1) {
          // 如果只有一个元素，是text框
          textArr.push({
            element: elements[0],
            pointid,
          });
        } else {
          // 如果有多个元素，放入临时数组
          tempArr.push({
            elements,
            pointid,
          });
        }
      });

      // 第二步：从临时数组中区分开关闸和线
      // 第二步：从临时数组中区分开关闸和线
      tempArr.forEach((group) => {
        // 找出组内所有带有value属性且值为0或1的元素
        const switchElements = group.elements.filter(el =>
          el.dataset.value == '0' || el.dataset.value == '1'
        );

        // 找出组内其他元素（线）
        const lineElements = group.elements.filter(el =>
          el.dataset.value !== '0' && el.dataset.value !== '1'
        );

        // 如果有开关元素，添加到开关数组
        if (switchElements.length > 0) {
          switchArr.push({
            ...group,
            elements: switchElements
          });
        }

        // 如果有线元素，添加到线数组
        if (lineElements.length > 0) {
          LineArr.push({
            ...group,
            elements: lineElements
          });
        }
      });
      console.log(switchArr, 'switchArr', LineArr, 'LineArr')

      // 4. 处理各类元素的值
      // 处理text框
      textArr.forEach((item) => {
        const pointInfo = idsObj.pointids.find(
          (p) => p.pointid === item.pointid
        );
        if (pointInfo) {
          const foreignObjects = item.element.querySelectorAll("foreignObject");
          foreignObjects.forEach((foreignObject) => {
            const divs = Array.from(
              foreignObject.querySelectorAll("div")
            ).filter((div) => div.parentElement !== foreignObject);

            divs.forEach((div) => {
              const originalColor = div.style.color || "black";
              console.log(originalColor)
              const originalFontSize = this.getFontSize(div);
              div.textContent = `${pointInfo.pointName}：${pointInfo.pointValueName}`;
              // div.style.color = '#fff';
              div.style.color = originalColor;
              div.style.fontSize = originalFontSize;
            });
          });
        }
      });

      // 处理开关闸
      switchArr.forEach((group) => {
        const pointInfo = idsObj.pointids.find(
          (p) => p.pointid === group.pointid
        );
        if (pointInfo) {
          group.elements.forEach((element) => {
            // 如果元素有value属性且与后台返回的值相匹配，显示该元素，否则隐藏
            if (element.dataset.value === pointInfo.pointValue) {
              element.style.display = "block";
            } else {
              element.style.display = "none";
            }
          });
        }
      });

      // 处理线
      LineArr.forEach((group) => {
        const pointInfo = idsObj.pointids.find(
          (p) => p.pointid === group.pointid
        );
        if (pointInfo) {
          group.elements.forEach((element) => {
            console.log(element, 'element线')
            // 根据point的值改变线的状态
            if (pointInfo.pointValue == "1") {
              this.updateElementColor(element, 'green')
              // element.style.stroke = "green";
            } else {
              this.updateElementColor(element, 'green')

              // element.style.stroke = "green";
            }
          });
        }
      });
    },
    getFontSize(element) {
      let fontSize = element.style.fontSize || "12px"; // 默认 12px

      // 如果没有行内样式，检查父元素
      if (!fontSize || fontSize === "0px") {
        const computedStyle = getComputedStyle(element);
        fontSize = computedStyle.fontSize || "12px";

        // 如果 computedStyle 中也没有字体大小，递归检查父元素
        if (fontSize === "0px" && element.parentElement) {
          return this.getFontSize(element.parentElement);
        }
      }

      return fontSize;
    },
    /**
     * 更新SVG元素及其子元素的颜色
     * @param {Element} element - 要更新的SVG元素
     * @param {string} newColor - 新的颜色值，如 'red', 'black' 等
     * @param {Object} options - 可选配置项
     * @param {boolean} options.updateFill - 是否更新fill属性，默认true
     * @param {boolean} options.updateStroke - 是否更新stroke属性，默认true
     */
    updateElementColor(element, newColor, options = {}) {
      const {
        updateFill = true,
        updateStroke = true
      } = options;

      // 获取元素的计算样式
      const style = window.getComputedStyle(element);

      // 更新fill
      if (updateFill && style.fill && style.fill !== 'none') {
        element.style.fill = newColor;
      }

      // 更新stroke
      if (updateStroke && style.stroke && style.stroke !== 'none') {
        element.style.stroke = newColor;
      }

      // 递归处理所有子元素
      Array.from(element.children).forEach(child => {
        this.updateElementColor(child, newColor, options);
      });
    },
    getAllDeviceIds() {
      const elements = this.$refs.svgContainer.querySelector("g[data-cell-id]");
      console.log(elements, "elements");
      return Array.from(elements).map((el) => el.getAttribute("data-deviceId"));
    },
    // 打开对话框
    openDialog(row, operate) {
      console.log(row, 'row');
      this.operate = operate
      const spaceForm = _.cloneDeep(row)
      if (operate === 'same') {
        this.spaceLabel = '同级组态空间';
        this.title = '新建同级组态空间';
        spaceForm.parentId = this.checkSpace.parentId;
        spaceForm.parentName = this.checkSpace.parentName;
        spaceForm.latitude = "";
        spaceForm.longitude = "";
        spaceForm.type = 0;
        spaceForm.cnName = ''; // 清空名称
      } else if (operate === 'children') {
        this.spaceLabel = '父级组态空间';
        this.title = '新建子级组态空间';
        spaceForm.parentId = this.checkSpace.id;
        spaceForm.parentName = this.checkSpace.title;
        spaceForm.latitude = "";
        spaceForm.longitude = "";
        spaceForm.type = 0;
        spaceForm.cnName = ''; // 清空名称
      } else if (operate === 'edit') {
        this.title = '编辑选中组态空间';
        this.spaceLabel = '操作组态空间';
        // 编辑时需要设置当前组态空间的名称
        spaceForm.cnName = row.title; // 设置当前组态空间名称
        spaceForm.region = ['100000'];
        if (spaceForm.provinceId) spaceForm.region.push(spaceForm.provinceId + '')
        if (spaceForm.cityId) spaceForm.region.push(spaceForm.cityId + '')
        if (spaceForm.districtId) spaceForm.region.push(spaceForm.districtId + '')
        if (spaceForm.streetId) spaceForm.region.push(spaceForm.streetId + '')
        if (this.levelType > 1) {
          spaceForm.region = spaceForm.region.splice(this.levelType - 1, spaceForm.region.length)
        }
        spaceForm.type = spaceForm.type === 1 ? spaceForm.type : 0;
      }
      this.spaceForm = spaceForm;
      this.deviceDialogVisible = true;
    },

    // 检查值
    checkValue() {
      if (!this.$stringIsNotNullAndEmpty(this.spaceForm.cnName)) {
        this.$message.error('请输入组态空间名称');
        return false;
      }
      if (this.spaceForm.cnName.length > 20) {
        this.$message.error('组态空间名称过长');
        return false;
      }
      return true;
    },

    // 保存
    preservation() {
      if (this.checkValue()) {
        const saveData = {
          ...this.spaceForm,
          type: this.spaceForm.type === 1 ? this.spaceForm.type : 2,
          systemType: this.systemType,
          code: this.spaceForm.region ? this.spaceForm.region[this.spaceForm.region.length - 1] : undefined,
          levelType: this.levelType
        };

        saveByLevel(saveData).then(res => {
          if (res.code === 0) {
            this.$message.success('操作成功');
          } else {
            this.$message.error(res.message);
          }
          this.deviceDialogVisible = false;
          this.getSpaceInfo();
          this.queryTopology();
          this.spaceForm = {};
          this.$refs.space.ztree();
        });
      }
    },

    // 删除组态空间
    removeSpace() {
      this.$confirm('是否确认删除组态空间：' + this.checkSpace.title, {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            deleteById(this.checkSpace.id).then(res => {
              if (res.code === 0) {
                this.$message.success('操作成功');
              } else {
                this.$message.error(res.message);
              }
              this.$refs.space.ztree();
            });
          }
        }
      })
    },

    // 关闭对话框
    close() {
      this.spaceForm = {};
      this.deviceDialogVisible = false;
    },
    changeType() {
      // 重置当前选中的组态空间
      this.checkSpace = {};

      // 清空SVG相关数据
      this.svgData = { url: '' };
      if (this.$refs.svgContainer) {
        this.$refs.svgContainer.innerHTML = '';
      }

      // 清除panzoom实例
      if (this.panzoom) {
        this.panzoom.dispose();
        this.panzoom = null;
      }

      // 重置搜索框
      this.name = '';

      // 如果有定时器，清除它
      if (this.updateTimer) {
        clearInterval(this.updateTimer);
        this.updateTimer = null;
      }

      // 在下一个DOM更新周期重新加载树组件
      this.$nextTick(() => {
        // 调用space-tree-show组件的ztree方法重新加载树数据
        // SpaceTreeShowCopy组件会基于传入的systemType加载相应数据
        this.$refs.space.ztree();

        console.log(`已切换系统类型为: ${this.systemType === '1' ? '电力' : this.systemType === '2' ? '群控' : 'PTMS'}`);
      });
    },

    // 获取组态空间信息
    getSpaceInfo() {
      getSpaceInfoById(this.checkSpace.id, this.systemType).then(res => {
        if (res.code === 0) {
          this.checkSpace = res.data;
        }
      })
    },

    select_status() {
      this.$forceUpdate();
    },

    beforeUpload(file) {
      return imgUploadAstrict(file, this);
    },

    imageChangeError() {
      this.$message.error("文件上传失败!");
    },

    imageChangeSuccess(file) {
      this.spaceForm.bgImage = file.data.domain + file.data.url;
      this.$forceUpdate();
    },

    imageRemove() {
      this.spaceForm.bgImage = '';
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  padding: 10px 10px 0;
  height: calc(100vh - 90px);
}

.space-choose {
  float: left;
  height: 100%;
  width: 250px;
}

.current-location {
  margin-top: 30px;
  margin-left: 25px;
  height: 19px;
  font-weight: 400;
  line-height: 19px;
  color: #ffffff;
  opacity: 1;

  img {
    margin-right: 5px;
  }
}

.space {
  margin: 20px 0 10px 30px;
  width: 160px;
  font-weight: 400;
  line-height: 19px;
  color: #ffffff;
  font-size: 0.85rem;
  opacity: 1;
}

.contentRight {
  margin-left: 270px;
  width: calc(100vw - 525px);
}

@media (max-width: 1028px) {
  .main {
    height: auto;
  }

  .space-choose {
    height: auto;
    width: 300px;
    float: none;
    padding-bottom: 10px;
  }

  .contentRight {
    width: 100%;
    height: 100%;
    margin: 20px 0;
  }
}

.space-button {
  margin-top: 20px;
}

.space-button span {
  margin: 0 5px 0 5px;
  width: 84px;

  height: 19px;
  line-height: 19px;
  color: #07E6F8;
  border-bottom: 1px solid #41a6ad;
  opacity: 1;
  cursor: pointer;
}

.text-danger {
  color: #fb2929 !important;
}

.delete-icon {
  line-height: 80px;
  height: 80px;
  width: 80px;
  position: absolute;
  text-align: center;
  display: none;
}

.upload-img {
  position: absolute;
  width: 80px;
  height: 80px;
}

.upload-div {
  margin-bottom: 145px;
}

.upload-img:hover+.delete-icon {
  display: block;
}

.delete-icon:hover {
  display: block;
}
</style>
